import { render, staticRenderFns } from "./testReportList.vue?vue&type=template&id=7d395ed8&"
import script from "./testReportList.vue?vue&type=script&lang=js&"
export * from "./testReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports